interface Props {
	content: {
		properties: {
			items: Array<{
				name: string;
			}>;
		};
	};
}

export function mapTagsList({ content }: Props): Content.SubjectTags {
	return {
		documentType: 'subjectTags',
		content,
	};
}
